import { Configuration } from "@azure/msal-browser";
import { MFTEnvironmentVariables } from "./MFTEnvironmentVariables";

export const msalConfig: Configuration = {
  auth: {
    clientId: MFTEnvironmentVariables.azureClientId.toString(),
    authority:
      "https://login.microsoftonline.com/7a7dc48e-9f70-4f4c-941e-bf8aa042f81a", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const graphRequest = {
  scopes: ["User.Read"],
};

export const algoApiRequest = {
  scopes: [MFTEnvironmentVariables.azureAlgoApiRequestScopes.toString()],
  prompt: "select_account",
};

/**
 * jepx-data-provider (JEPX spot prices). A distinct audience from
 * {@link algoApiRequest}, so it needs its own token.
 */
export const jepxDataProviderRequest = {
  scopes: [MFTEnvironmentVariables.azureJepxDataProviderScopes.toString()],
};
